export default "/_next/static/images/0a4ee3b6097c25b8d714fd1b640358b2.png";